import {apiUserLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {getIgnoredNotifyResponse} from "../../store/utils/get_ignored_notify_response";

export const postUserPhoneVerificationCodeApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        postUserPhoneVerificationCode: build.mutation<void, void>({
            query: () => {
                const url = apiUserLink.user.sendPhoneVerificationCode;
                return {
                    url,
                    method: "POST"
                };
            },
            transformErrorResponse: (response) => {
                getIgnoredNotifyResponse(response, [400, 409, 429]);

                if (response.status === 400) {
                    return {data: {error: "Brak numeru tel"}, status: 400};
                }
                if (response.status === 409) {
                    return {data: {error: "Numer już zweryfikowany"}, status: 409};
                }
                if (response.status === 429) {
                    return {data: {error: "Przekroczono limit żądań wygenerowania kodu - spróbuj ponownie później"}, status: 429};
                }
                return response.data;
            }
        })
    })
});

export const {usePostUserPhoneVerificationCodeMutation} = postUserPhoneVerificationCodeApi;
